export default "__VITE_ASSET__BOZUxU4o__"